export const PlanType: { [key: number]: string } = {
  '1': 'Prototype Project',
  '2': 'Blog Post',
  '3': 'Vendor Certification',
};
